export default {
    BusinessImportHistory: {
        page: {
            importTemplate: '导入模板',
            importBatchNumber: '导入批次号',
            totalData: '数据总量',
            templateName: '模板名称',
            templateCode: '模板代码',
            TemplateType: '模板类型',
            CustomTemplateName: '自定义模板名称',
            Description: '描述',

            GeneralImport: '通用导入',
            pathPrefix: '客户端路径前缀',
            Slicing: '分片',
            CustomTemplate: '自定义模板',
            SheetPage: 'Sheet页',
            numberPage: '序号页',
            PageName: '页名称',
            startLine: '导入起始行',
            templateColumns: '维护模板列',
            PleaseTemplateName: '请输入模板名称',
            PleasetemplateCode: '请输入模板代码',
            PleaseTemplateType: '请选择模板类型',
            PleasePathPrefix: '请输入路径前缀',
            PleaseSheetPage: '请选择Sheet页',
            PleasePageName: '请输入页名称',
            SelectFile: '选取文件',

            ColumnCode: '列编码',
            ColumnName: '列名',
            ColumnType: '列类型',
            FormatMask: '格式掩码',
            Length: '长度',
            Maximum: '最大值',
            Minimum: '最小值',
            ValidateValue: '验证值集',
            RegularExpression: '正则式',
            NullAllowed: '允许为空',
            DataValidation: '数据验证',
            ColumnNumber: '列号',
            SampleData: '示例数据',
            ValueConversion: '值集转换',
            PleaseSerialNumber: '请输入列序号',
            PleaseColumnNumber: '请输入列编号',
            PleaseColumnName: '请输入列名',
            PleaseColumnType: '请输入列类型',
            EditColumn: '编辑列',
            CreateColumn: '新建列',
        }
    }
};
